import { useState } from 'react';

export function useVisitModals() {
  const [showVisitDetailsModal, setShowVisitDetailsModal] = useState(false);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationVisit, setConfirmationVisit] = useState(null);
  const [savedConfirmationVisitForNotConfirmed, setSavedConfirmationVisitForNotConfirmed] = useState(null);
  const [showVisitNotConfirmedModal, setShowVisitNotConfirmedModal] = useState(false);
  const [deniedCommitmentId, setDeniedCommitmentId] = useState(null);
  const [showResponseRegisteredModal, setShowResponseRegisteredModal] = useState(false);
  const [whatHappenedText, setWhatHappenedText] = useState('');
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationAlreadyConfirmed, setValidationAlreadyConfirmed] = useState(false);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [feedbackType, setFeedbackType] = useState('agreement');
  const [showConsultantRatingModal, setShowConsultantRatingModal] = useState(false);
  const [showDaysTooltip, setShowDaysTooltip] = useState(false);

  return {
    showVisitDetailsModal, setShowVisitDetailsModal,
    selectedVisit, setSelectedVisit,
    whatHappenedText, setWhatHappenedText,
    showConfirmationModal, setShowConfirmationModal,
    confirmationVisit, setConfirmationVisit,
    savedConfirmationVisitForNotConfirmed, setSavedConfirmationVisitForNotConfirmed,
    showVisitNotConfirmedModal, setShowVisitNotConfirmedModal,
    deniedCommitmentId, setDeniedCommitmentId,
    showResponseRegisteredModal, setShowResponseRegisteredModal,
    showValidationModal, setShowValidationModal,
    validationAlreadyConfirmed, setValidationAlreadyConfirmed,
    showThankYouModal, setShowThankYouModal,
    feedbackType, setFeedbackType,
    showConsultantRatingModal, setShowConsultantRatingModal,
    showDaysTooltip, setShowDaysTooltip,
  };
}
